module.exports = function() {
  return new Worker(__webpack_public_path__ + "91e723ea6aa6fb67.worker.js");
};